module.exports = __webpack_public_path__ + "img/xia.3136bccb.svg";